import { DateTimePicker } from "../core/components/dateTimePicker";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { HTTPService } from "../core/util/httpManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";

export default class TimeZoneSummary extends React.Component<TimezoneSummaryProps, any> {
    private _componentFactory = ComponentHelper.createFactory();
    private _popUpStyle: React.CSSProperties = {
        display: "flex",
        padding: 5,
    };
    private _popUpColumnStyle: React.CSSProperties = {
        flex: 1,
        width: "250px",
        padding: "5px"
    };
    private _spacerStyle: React.CSSProperties = {
        marginBottom: "9px",
        display: "flex",
        flexDirection: "column"
    };
    private _labelStyle: React.CSSProperties = {
        marginBottom: "2px",
        fontWeight: "bold",
        display: "block"
    };
    private _subLabelStyle: React.CSSProperties = {
        marginBottom: "5px",
        fontSize: "10px",
        display: "block"
    };
    private _modelNames = {
        startIstName: "entity.StartIst",
        endeIstName: "entity.EndeIst",
        arbeitsbeginnName: "entity.Arbeitsbeginn",
        arbeitsendeName: "entity.Arbeitsende"
    };
    private _locationTimeZone = null;
    private _resourceTimeZone = null;
    private _userTimeZone = null;
    private _originalDates: StringKeyDictionary<String> = {};
    private _converted = {
        user: {} as StringKeyDictionary<String>,
        resource: {} as StringKeyDictionary<String>
    };

    constructor(props) {
        super(props)
        this._originalDates[this._modelNames.startIstName] = this._getDateField(this.props.startIst);
        this._originalDates[this._modelNames.endeIstName] = this._getDateField(this.props.endeIst);
        this._originalDates[this._modelNames.arbeitsbeginnName] = this._getDateField(this.props.arbeitsbeginn);
        this._originalDates[this._modelNames.arbeitsendeName] = this._getDateField(this.props.arbeitsende);
    }

    private _getDateField = (date: any) => {
        if (date instanceof Date) {
            return kendo.toString(date, "s");
        } else {
            if (typeof date === "string" && date.indexOf("+") !== -1) {
                return date.substring(0, date.indexOf("+"));
            } else {
                return date;
            }
        }
    }

    private _refreshData = () => {
        HTTPService.get(
            "TimeZone/GetAssignmentTimeZoneInfo",
            {
                ProjNr: this.props.projNr,
                PIndex: this.props.pIndex,
                AdrNr: this.props.adrNr,
                RessNr: this.props.ressNr,
                StartIst: this._originalDates[this._modelNames.startIstName],
                EndeIst: this._originalDates[this._modelNames.endeIstName],
                Arbeitsbeginn: this._originalDates[this._modelNames.arbeitsbeginnName],
                Arbeitsende: this._originalDates[this._modelNames.arbeitsendeName]
            }
        ).then(result => {
            this._converted.resource[this._modelNames.startIstName] = Helper.hasValue(result.Resource.StartDate) ? result.Resource.StartDate : null;
            this._converted.resource[this._modelNames.endeIstName] = Helper.hasValue(result.Resource.EndDate) ? result.Resource.EndDate : null;
            this._converted.resource[this._modelNames.arbeitsbeginnName] = Helper.hasValue(result.Resource.StartOfWork) ? result.Resource.StartOfWork : null;
            this._converted.resource[this._modelNames.arbeitsendeName] = Helper.hasValue(result.Resource.EndOfWork) ? result.Resource.EndOfWork : null;

            this._converted.user[this._modelNames.startIstName] = Helper.hasValue(result.User.StartDate) ? result.User.StartDate : null;
            this._converted.user[this._modelNames.endeIstName] = Helper.hasValue(result.User.EndDate) ? result.User.EndDate : null;
            this._converted.user[this._modelNames.arbeitsbeginnName] = Helper.hasValue(result.User.StartOfWork) ? result.User.StartOfWork : null;
            this._converted.user[this._modelNames.arbeitsendeName] = Helper.hasValue(result.User.EndOfWork) ? result.User.EndOfWork : null;

            this._locationTimeZone = Helper.hasValue(result.Location.TimeZoneName) ? result.Location.TimeZoneName : "n/a";
            this._resourceTimeZone = Helper.hasValue(result.Resource.TimeZoneName) ? result.Resource.TimeZoneName : "n/a";
            this._userTimeZone = Helper.hasValue(result.User.TimeZoneName) ? result.User.TimeZoneName : "n/a";

            this.setState({});
        });
    }

    private _renderField = (fieldName: string, label: string, isResource: boolean) => {
        const props = this._componentFactory.getDefaultDateTimePickerProps();
        props.field.readOnly = true;
        props.disabled = true;
        props.value = isResource ? this._converted.resource[fieldName] : this._converted.user[fieldName];
        //check if there's a valid value and if not, fallback to the original one
        props.value = props.value || this._originalDates[fieldName];
        let value = (isResource ? this._converted.resource[fieldName] : this._converted.user[fieldName]) as string;
        value = props.value || this._originalDates[fieldName];
        console.log()

        return (
            <div style={this._spacerStyle}>
                <label>{label}</label>
                {`${kendo.toString(kendo.parseDate(value), 'd')} ${kendo.toString(kendo.parseDate(value), 'hh:mm')}` }
            </div>
        );
    }

    componentDidMount() {
        this._refreshData();
    }

    render() {
        return (
            <div style={this._popUpStyle}>
                <div style={this._popUpColumnStyle}>
                    <label className="truncate" style={this._labelStyle}>{this.props.translations.resourceTimeZone}</label>
                    <label className="truncate" style={this._subLabelStyle} title={this._resourceTimeZone}>{this._resourceTimeZone}</label>
                    {this._renderField(this._modelNames.startIstName, this.props.translations.startIst, true)}
                    {this._renderField(this._modelNames.arbeitsbeginnName, this.props.translations.arbeitsbeginn, true)}
                    {this._renderField(this._modelNames.arbeitsendeName, this.props.translations.arbeitsende, true)}
                    {this._renderField(this._modelNames.endeIstName, this.props.translations.endeIst, true)}
                </div>
                <div style={this._popUpColumnStyle}>
                    <label className="truncate" style={this._labelStyle}>{this.props.translations.userTimeZone}</label>
                    <label className="truncate" style={this._subLabelStyle} title={this._userTimeZone}>{this._userTimeZone}</label>
                    {this._renderField(this._modelNames.startIstName, this.props.translations.startIst, false)}
                    {this._renderField(this._modelNames.arbeitsbeginnName, this.props.translations.arbeitsbeginn, false)}
                    {this._renderField(this._modelNames.arbeitsendeName, this.props.translations.arbeitsende, false)}
                    {this._renderField(this._modelNames.endeIstName, this.props.translations.endeIst, false)}
                </div>
            </div>
        );
    }
}

export interface TimezoneSummaryProps {
    projNr: string;
    pIndex: number;
    ressNr: string;
    adrNr: string;
    startIst: string;
    endeIst: string;
    arbeitsbeginn: string;
    arbeitsende: string;
    translations: {
        startIst: string;
        endeIst: string;
        arbeitsbeginn: string;
        arbeitsende: string;
        resourceTimeZone: string;
        userTimeZone: string;
    }
}